/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface AsyncTaskData
 *
 */
// create custom validators for the regexes
export interface AsyncTaskData {
    /**
     *
     * #type string
     * #memberof AsyncTaskData
        
        
         */
    jobId: string;
}
/**
 * Check if a given object implements the AsyncTaskData interface.
 */
export function instanceOfAsyncTaskData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobId" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const AsyncTaskDataTypiaAssertEquals = (input: any) => {
    return ((input: any): AsyncTaskData => {
        const __is = (input: any, _exceptionable: boolean = true): input is AsyncTaskData => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.jobId && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["jobId"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is AsyncTaskData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.jobId || $guard(_exceptionable, {
                    path: _path + ".jobId",
                    expected: "string",
                    value: input.jobId
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["jobId"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "AsyncTaskData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "AsyncTaskData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const AsyncTaskDataTypiaAssertStringify = (input: AsyncTaskData): string => {
    return ((input: any): string => { const assert = (input: any): AsyncTaskData => {
        const __is = (input: any): input is AsyncTaskData => {
            return "object" === typeof input && null !== input && "string" === typeof (input as any).jobId;
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is AsyncTaskData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.jobId || $guard(_exceptionable, {
                    path: _path + ".jobId",
                    expected: "string",
                    value: input.jobId
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "AsyncTaskData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "AsyncTaskData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: AsyncTaskData): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"jobId":${$string((input as any).jobId)}}`;
    }; return stringify(assert(input)); })(input);
};
export const AsyncTaskDataValidatorShape = {
    'jobId': yup.string().defined(),
};
export const AsyncTaskDataValidator = yup.object().shape(AsyncTaskDataValidatorShape);
export const AsyncTaskDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'jobId': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const AsyncTaskDataStringifyShape: ObjectSchema = {
    title: 'AsyncTaskData Stringifier',
    type: 'object',
    properties: {
        ...AsyncTaskDataStringifyShapeProperties
    },
    required: [
        'jobId',
    ],
};
export const AsyncTaskDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(AsyncTaskDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const AsyncTaskDataStringify: (data: AsyncTaskData) => string = AsyncTaskDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function AsyncTaskDataFromJSON(json: any): AsyncTaskData {
    return AsyncTaskDataFromJSONTyped(json, false);
}
export function AsyncTaskDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsyncTaskData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'jobId': json['jobId'],
    };
}
export function AsyncTaskDataToJSON(value?: AsyncTaskData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'jobId': value.jobId,
    };
}
